<template>
    <div class="panel__tab">
        <div class="name" :data-icoTarget="valueIco" @click="$emit('togglePanel')">
            {{ title }}
            <div class="icoButton__options">
                <div class="icoButton icoButton__downUp" data-icoTarget="up"></div>
            </div>
        </div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'ui-PanelTab',
        props: {
            valueIco: String,
            title: String,
        },
    };
</script>
